import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';

// Desktop UI for Headcount — one wide table.
export default function HeadcountDesktop({ vm }) {
  const { loading, perFunction, grand, isTwoSided } = vm;
  return (
    <div>
      <div className="page-head"><h1>Headcount</h1></div>
      <div className="muted" style={{ marginBottom: 12, fontSize: 13 }}>
        Expected persons per function — give these to the venue owner for catering / dinner.
        Parties are deduped by mobile, so a family invited by several members counts once. Private guests are included.
      </div>
      {loading ? <Spinner /> : (
        <div className="card table-wrap">
          <table className="tbl">
            <thead>
              <tr>
                <th>Function</th><th>Date</th><th>Parties</th><th>Persons</th>
                {isTwoSided && <><th>Groom side</th><th>Bride side</th><th>Common</th></>}
              </tr>
            </thead>
            <tbody>
              {perFunction.map(({ fn, parties, persons, bySide }) => (
                <tr key={fn.FunctionId} className="row-link" title="Open guests of this function" onClick={() => vm.openRow(fn)}>
                  <td><strong>{fn.FunctionName}</strong></td>
                  <td>{fmtDate(fn.FunctionDate)}{fn.FunctionTime ? ` · ${fmtTime(fn.FunctionTime)}` : ''}</td>
                  <td>{parties}</td>
                  <td><strong>{persons}</strong></td>
                  {isTwoSided && <><td>{bySide.Groom}</td><td>{bySide.Bride}</td><td>{bySide.Common}</td></>}
                </tr>
              ))}
              {perFunction.length === 0 && <tr><td colSpan={isTwoSided ? 7 : 4} className="empty">No functions yet.</td></tr>}
            </tbody>
            {perFunction.length > 0 && (
              <tfoot>
                <tr>
                  <td colSpan={2}><strong>All functions</strong></td>
                  <td><strong>{grand.parties}</strong></td>
                  <td><strong>{grand.persons}</strong></td>
                  {isTwoSided && <td colSpan={3} className="muted">person-visits (someone invited to both counts in each)</td>}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      )}
    </div>
  );
}
